import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { firebaseDb } from '../firebase';

export const couponService = {
  /**
   * Créer un coupon (Admin)
   */
  createCoupon: async (couponData) => {
    return { success: false, error: 'Création admin non disponible côté client (Firebase-only).' };
  },

  /**
   * Obtenir tous les coupons
   */
  getCoupons: async (activeOnly = false) => {
    try {
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré', coupons: [], count: 0 };
      }
      let q = query(collection(firebaseDb, 'coupons'));
      if (activeOnly) {
        q = query(collection(firebaseDb, 'coupons'), where('isActive', '==', true));
      }
      const snap = await getDocs(q);
      const coupons = snap.docs.map((d) => ({ id: d.id, _id: d.id, ...d.data() }));
      return {
        success: true,
        coupons,
        count: coupons.length,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des coupons:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la récupération des coupons',
        coupons: [],
      };
    }
  },

  /**
   * Obtenir un coupon par code
   */
  getCouponByCode: async (code) => {
    try {
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré' };
      }
      const ref = doc(firebaseDb, 'coupons', String(code).toUpperCase());
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        return { success: false, error: 'Coupon introuvable' };
      }
      return {
        success: true,
        coupon: { id: snap.id, _id: snap.id, ...snap.data() },
      };
    } catch (error) {
      console.error('Erreur lors de la récupération du coupon:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la récupération du coupon',
      };
    }
  },

  /**
   * Valider un coupon
   */
  validateCoupon: async (code, orderAmount, orderId, platform) => {
    // Validation simple côté client (pas de tracking d’usage). Pour de vraies règles métier, passer par Cloud Functions.
    const res = await couponService.getCouponByCode(code);
    if (!res.success) return res;
    const coupon = res.coupon;
    if (coupon.isActive === false) {
      return { success: false, error: 'Coupon inactif' };
    }
    const percent = Number(coupon.percent || coupon.discountPercent || 0);
    const discountAmount = Math.max(0, (Number(orderAmount) || 0) * (percent / 100));
    const finalAmount = Math.max(0, (Number(orderAmount) || 0) - discountAmount);
    return {
      success: true,
      coupon,
      discountAmount,
      orderAmount,
      finalAmount,
    };
  },

  /**
   * Appliquer un coupon à une commande
   */
  applyCoupon: async (code, orderId) => {
    return { success: false, error: 'Application coupon sur commande: à implémenter via Firestore/Functions.' };
  },

  /**
   * Mettre à jour un coupon (Admin)
   */
  updateCoupon: async (couponId, updateData) => {
    return { success: false, error: 'Mise à jour admin non disponible côté client (Firebase-only).' };
  },

  /**
   * Supprimer un coupon (Admin)
   */
  deleteCoupon: async (couponId) => {
    return { success: false, error: 'Suppression admin non disponible côté client (Firebase-only).' };
  },

  /**
   * Obtenir les statistiques d'un coupon (Admin)
   */
  getCouponStats: async (couponId) => {
    return { success: false, error: 'Stats admin non disponibles côté client (Firebase-only).' };
  },
};





